/**
 * Right-panel tab ids for the skill-grids feature. Shared between the manifest
 * (which registers the panel view) and the center views (which open/focus it via
 * `useLayoutStore`). Keep in sync with `manifest.ts`.
 */

/** "Add a checkbox" form (checkbox + weight). Create and edit. */
export const CHECKBOX_LINK_TAB = 'checkbox-link';
